import { Skeleton } from "@/components/ui/skeleton";

export default function IntrusionLogSkeleton() {
  return (
    <div className="flex flex-col pl-3 max-md:!pr-6 !pr-8 py-3 mt-12 font-primary font-semibold gap-4">
      {/* Title */}
      <Skeleton className="h-8 w-48" />

      {/* Search bar + Download button row */}
      <div className="flex gap-4 items-center">
        <Skeleton className="h-12 flex-1 rounded-lg" />
        <Skeleton className="h-12 w-48 rounded-lg" />
      </div>

      {/* Date range selector row */}
      <div className="flex gap-3 items-center">
        <Skeleton className="h-10 w-36 rounded-full" />
        <Skeleton className="h-10 w-28 rounded-lg" />
        <Skeleton className="h-10 w-28 rounded-lg" />
      </div>

      {/* Filter dropdowns row */}
      <div className="grid grid-cols-4 gap-4 max-md:grid-cols-2">
        <Skeleton className="h-14 rounded-lg" />
        <Skeleton className="h-14 rounded-lg" />
        <Skeleton className="h-14 rounded-lg" />
        <Skeleton className="h-14 rounded-lg" />
      </div>

      {/* Table header */}
      <div className="grid grid-cols-7 gap-4 mt-2">
        <Skeleton className="h-5 w-16" />
        <Skeleton className="h-5 w-24" />
        <Skeleton className="h-5 w-28" />
        <Skeleton className="h-5 w-32" />
        <Skeleton className="h-5 w-20" />
        <Skeleton className="h-5 w-20" />
        <Skeleton className="h-5 w-12" />
      </div>

      {/* Table rows */}
      {Array.from({ length: 6 }).map((_, i) => (
        <div
          key={i}
          className="grid grid-cols-7 gap-4 items-center py-3 border-b border-zinc-100"
        >
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-4 w-36" />
          <Skeleton className="h-8 w-12" />
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-4 w-44" />
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-8 w-8 rounded-full" />
        </div>
      ))}
    </div>
  );
}
